module.exports = __webpack_public_path__ + "assets/icon-unlocked-light-gray.f0816bfd.svg";